export class SetApiKey {
    static readonly type = "[APP] Set API Key";
    constructor(public payload: string) {}
}
